import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Calendar, ArrowUpRight, CheckCircle2, ArrowLeft, Mail, Phone } from "lucide-react";

const CALENDLY_URL = "/book";

export default function ThankYouPage() {
  useEffect(() => {
    // Fire conversion events when user lands on thank-you (actual conversion moment)
    try {
      if (window.fbq) window.fbq("track", "Lead", { content_name: "PersonalBrandingLanding" });
      if (window.gtag) {
        window.gtag("event", "conversion", { send_to: "AW-18010926040" });
        window.gtag("event", "generate_lead", { value: 1, currency: "INR" });
      }
      if (window.dataLayer) window.dataLayer.push({ event: "lead_submitted" });
    } catch (e) {
      // swallow
    }
  }, []);

  return (
    <div className="landing-light min-h-screen flex flex-col">
      <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-xl border-b border-black/5">
        <div className="max-w-7xl mx-auto px-4 md:px-8 h-14 md:h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center" data-testid="thankyou-logo">
            <img src="/assets/logo_light.png" alt="BrandChilly" className="h-7 md:h-9 w-auto" />
          </Link>
          <Link to="/" className="text-xs text-zinc-500 hover:text-black transition flex items-center gap-1.5" data-testid="thankyou-home">
            <ArrowLeft size={13} /> Home
          </Link>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-5 md:px-8 py-16 md:py-24">
        <div className="max-w-2xl w-full text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-full bg-red-50 border border-red-100 mb-7">
            <CheckCircle2 size={32} className="l-red" strokeWidth={1.6} />
          </div>

          <div className="l-eyebrow mb-4">Submission received</div>

          <h1 className="text-4xl sm:text-5xl md:text-6xl leading-[1.05]" style={{ fontFamily: "Cormorant Garamond, serif" }}>
            Thank <span className="l-red italic">you</span> for submitting your details.
          </h1>

          <p className="mt-6 text-base md:text-lg text-zinc-600 leading-relaxed max-w-lg mx-auto">
            Our team will get in touch with you shortly. If you'd like to book a
            one-on-one discovery call right now, click below.
          </p>

          <a
            href={CALENDLY_URL}
            className="l-btn-primary mt-9 text-base py-4 px-8"
            data-testid="thankyou-calendly-btn"
          >
            <Calendar size={18} /> Book a Discovery Call <ArrowUpRight size={18} />
          </a>

          <div className="mt-10 pt-10 border-t border-black/5 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-sm text-zinc-500">
            <a href="mailto:brandchilly@gmail.com" className="flex items-center gap-2 hover:text-black transition">
              <Mail size={14} className="l-red" /> brandchilly@gmail.com
            </a>
            <a href="tel:+918979106414" className="flex items-center gap-2 hover:text-black transition">
              <Phone size={14} className="l-red" /> +91 89791 06414
            </a>
          </div>
        </div>
      </main>
    </div>
  );
}
